module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    class: _vm.btnWidth,
    attrs: {
      "id": "Botao-Aplicacao-Wrapper"
    },
    on: {
      "click": _vm.btnClickFunction
    }
  }, [_c('div', [_c('div', {
    staticClass: "img-troca-app",
    class: _vm.btnActive ? 'rounded-div-active' : 'rounded-div',
    attrs: {
      "name": 'rounded-div-image-' + _vm.btnAppId
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.btnImg,
      "width": "65",
      "height": "65"
    }
  })]), _c('span', {
    class: _vm.btnActive ? 'mark' : 'transp-mark',
    domProps: {
      "innerHTML": _vm._s(_vm.$t('trocaApp.labels.voceAqui'))
    }
  })]), _c('h4', {
    class: _vm.btnActive ? 'app-font bold' : 'app-font',
    domProps: {
      "innerHTML": _vm._s(_vm.btnDesc)
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-081ec6ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-081ec6ca"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/buttonApplication/buttonApplication.pug
// module id = 1361
// module chunks = 0